import React from "react";

const PhoneIcon = () => {
	return (
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="28" cy="28" r="28" fill="#F6F6F6" />
			<g clipPath="url(#clip0_16383_36868)">
				<path
					d="M17.6842 16.2109H23.579L26.5263 23.5794L22.8421 25.7899C24.4204 28.99 27.0104 31.5801 30.2105 33.1583L32.4211 29.4741L39.7895 32.4215V38.3162C39.7895 39.0979 39.479 39.8476 38.9262 40.4003C38.3735 40.953 37.6238 41.2636 36.8421 41.2636C31.0937 40.9142 25.6718 38.4731 21.5995 34.4009C17.5273 30.3286 15.0862 24.9068 14.7368 19.1583C14.7368 18.3766 15.0474 17.6269 15.6001 17.0742C16.1528 16.5215 16.9025 16.2109 17.6842 16.2109"
					stroke="var(--general-count-action-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.4211 20.6328C33.2027 20.6328 33.9524 20.9433 34.5052 21.4961C35.0579 22.0488 35.3684 22.7985 35.3684 23.5802"
					stroke="var(--general-count-action-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M32.4211 14.7383C34.7661 14.7383 37.0151 15.6699 38.6734 17.3281C40.3316 18.9863 41.2632 21.2353 41.2632 23.5804"
					stroke="var(--general-count-action-color)"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_16383_36868">
					<rect width="35.3684" height="35.3684" fill="white" transform="translate(10.3158 10.3164)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default PhoneIcon;
